import './App.css';
import Navbar from './Components/navbar/Navbar';
import Section from './Components/Section';

function App() {
  return (
    <div className="App">
      <Navbar/>
      <Section/>
    </div>
  );
}

export default App;
